// extracted by mini-css-extract-plugin
module.exports = {"efAppH5A":"A_efAppH5A__8UUgA"};